import * as React from 'react';
import ReactDOM from 'react-dom';
import { Dialog,DialogFooter  } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton} from 'office-ui-fabric-react/lib/Button';

import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

import { Config } from './Config.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

import { AreaClientePanel } from './AreaClientePanel.js';


import './css/DialogBox.css';
import './css/PrimoAccesso.css';

const sessione = new Session();
const config = new Config();
const utils = new Utils();

export class PrimoAccesso extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: false,
            version : config.getVersion(),
            classeHeader : 'loginpage',
            
            codcliente: '',
            piva: '',
            password1:'',
            password2:'',
            mail:'',
            mail2:'',
            
            codclienteError : '...compilare...',
            pivaError : '...compilare...',
            passwordError : '...compilare...',
            passwordError2 : '...compilare...',
            mailError : '...compilare...',
            mailError2 : '...compilare...',
            
            buttonDisabled : false,

            checkAbilitato : false,

            showLOGIN_PRIVACY : 'nascosto',
            textLOGIN_PRIVACY : '',
            
            classLogo : "logo",
            
            textREGISTRATI : "Primo Accesso",
            
            classemail : 'nascosto',
            classepassword : 'nascosto',
            classemostra : 'nascosto',
            
            usainviomail : 'NO',
            messaggio : ''
            
        };
        
        this.inizializzaCheck = this.inizializzaCheck.bind(this);

        this.execLogin = this.execLogin.bind(this);
        this._onCheckboxChange = this._onCheckboxChange.bind(this);
        this.caricaAreaClientiPanel = this.caricaAreaClientiPanel.bind(this);
        
        this._controllaAbilitazioneBottone = this._controllaAbilitazioneBottone.bind(this);
        this.controllaParametri = utils.controllaParametri.bind(this);        
        this.controllaTipoRegistrazione = this.controllaTipoRegistrazione.bind(this);
        this.leggiQuerystring = this.leggiQuerystring.bind(this);
        
        this.centralogo = this.centralogo.bind(this);
    }
    
    componentDidMount() {
        this.centralogo(0);
    
        this.inizializzaCheck();
        this.controllaParametri(0);
        this.controllaTipoRegistrazione(0);
        
        this.leggiQuerystring();
    }
    
    leggiQuerystring(){
        let urlParams = config.leggiParametri();
        
        if( true === urlParams.has('CC') ){
            this.setState({ codcliente : urlParams.get('CC') , codclienteError:'' });
        }
        
        if( true === urlParams.has('PIVA') ){
            this.setState({ piva : urlParams.get('PIVA') , pivaError:'' });
        }
        
        if( true === urlParams.has('MAIL') ){
            this.setState({ mail : urlParams.get('MAIL') , mail2 : urlParams.get('MAIL') ,mailError:'', mailError2:'' });
        }
    }
    
    centralogo(conta){
        let posLogo = utils.getObjInfoSocieta( 'POSIZIONELOGOAC2' , false );
        if( posLogo !== false && conta < 50 ) {  
            if(posLogo === 'centro'){ this.setState({classeHeader: 'loginpage pagecentrato'}); } 
            let logolargo = utils.getObjInfoSocieta( 'LOGOLARGO' , false );
            if( logolargo !== false && logolargo==='SI'){ this.setState({classLogo: 'logo logolargo'}); }
        }
        else { setTimeout( function(){  this.centralogo( conta+1 );  }.bind(this) , 50 ); }
    }
    
    controllaTipoRegistrazione(conta){
        let usamail = utils.getObjInfoSocieta( 'REGISTRACONMAIL' , false );
        
        if(usamail === 'SI' && conta < 100){
            this.setState({classemail:'', classepassword:'nascosto' , usainviomail:'SI', classemostra:''});
        }else if(usamail === 'NO' && conta < 100){
            this.setState({classemail:'nascosto', classepassword:'' , usainviomail:'NO', classemostra:''});
        } else {
            setTimeout( function(){  this.controllaTipoRegistrazione( conta+1 );  }.bind(this) , 25 );
        }
    }
    
    
    inizializzaCheck(){
        if( this.state.showLOGIN_PRIVACY === 'nascosto' ){ 
            this.setState({ checkAbilitato: true });
        }
    }
    
    _onCheckboxChange(ev , flaggato)
    {
        this.setState({ checkAbilitato:flaggato});
        this._controllaAbilitazioneBottone();
    }
  
    _controllaAbilitazioneBottone()
    {
        setTimeout( function(){
            
            var abilitato = false;
            
            if( this.state.checkAbilitato === true ){ abilitato = true }
            if( this.state.codclienteError !== ''){ abilitato = false }
            
            if( this.state.usainviomail === 'NO'){
                if( this.state.pivaError !== ''){ abilitato = false }
                if( this.state.passwordError !== ''){ abilitato = false }
                if( this.state.passwordError2 !== ''){ abilitato = false }
            } else {
                if( this.state.mailError !== ''){ abilitato = false }
                if( this.state.mailError2 !== ''){ abilitato = false }
            }
            
            this.setState({ buttonDisabled:!abilitato });
            
        }.bind(this) , 100 );
    }
    
    
    codclienteChanged = (newValue) => { 
        if( newValue.length === 0 ){this.setState({codcliente: newValue,codclienteError: '...compilare...'}); }
        else{this.setState({codcliente: newValue,codclienteError: ''}); }
        
        this._controllaAbilitazioneBottone();
    }

    pivaChanged = (newValue) => { 
        if( newValue.length === 0 ){this.setState({piva: newValue,pivaError: '...compilare...'}); }
        else{this.setState({piva: newValue,pivaError: ''}); }
        
        this._controllaAbilitazioneBottone();
    }

    mailChanged = (newValue) => { 
        if( newValue.length === 0 ){this.setState({mail: newValue,mailError: '...compilare...'}); }
        else{     
            let isValidMail = utils.validateEmail(newValue);
            if(isValidMail){ this.setState({mail: newValue,mailError: ''});}
            else{this.setState({mail: newValue,mailError: '...mail non valida...'});}
        }
        
        this._controllaAbilitazioneBottone();
    }

    mail2Changed = (newValue) => { 
        if( newValue.length === 0 ){this.setState({mail2: newValue,mailError2: '...compilare...'}); }
        else if(this.state.mail !== newValue ){
            this.setState({mail2: newValue,mailError2: '...Le E-Mail devono essere uguali...'});
        }
        else{     
            let isValidMail = utils.validateEmail(newValue);
            if(isValidMail){ this.setState({mail2: newValue,mailError2: ''});}
            else{this.setState({mail2: newValue,mailError2: '...mail non valida...'});}
        }
        
        this._controllaAbilitazioneBottone();
    }

    password1Changed = (newValue) => { 
        if( newValue.length < 8 ){ this.setState({ password1: newValue, passwordError: 'La Lunghezza della password deve essere almeno di 8 caratteri'}); } 
        else {this.setState({ password1: newValue, passwordError: ''});}
        
        if( this.state.password2 !== newValue ){ this.setState({ passwordError2: 'Le Password devono essere uguali'}); } 
        
        this._controllaAbilitazioneBottone();
    }
    
    password2Changed = (newValue) => {
        if( this.state.password1 !== newValue || newValue === '' ){ this.setState({ password2: newValue, passwordError2: 'Le Password devono essere uguali'}); } 
        else {this.setState({ password2: newValue , passwordError2: ''});}
        
        this._controllaAbilitazioneBottone();
    }

  
    execLogin = (event) => {
        
        if(this.state.usainviomail === 'NO'){

            this.setState({codclienteError: '', passwordError: ''});
            
            let request = new Request( config.get("customers_firstlogin") ,{
                method: 'POST',mode: 'cors', credentials: "include",
                body: JSON.stringify({username: this.state.codcliente, piva: this.state.piva, password: this.state.password1 })
            });


            fetch(request)
            .then(function(response){
                return response.json();
            })
            .then(function(result){
                if (result.success){

                    // acquisisco in SESSIONE l'ID del cliente
                    sessione.set('id_cliente' ,result.data.id_cliente );

                    // LEGGO le configurazioni Personali x l'utente
                    utils.leggiImpostazioniPersonali();

                    // qui provo il caricamento del pannello
                    this.caricaAreaClientiPanel();

                } else {
                    this.setState({codclienteError: result.message, pivaError: ' '});
                }
            }.bind(this)).catch(function() {
                this.setState({codclienteError: 'Errore invio dati', pivaError: ' '});
            }.bind(this));
        
        } else {

            let request = new Request( config.get("customers_firstloginmail") ,{
                method: 'POST',mode: 'cors', credentials: "include",
                body: JSON.stringify({action:'primoaccesso',username: this.state.codcliente, mail: this.state.mail , pathAC: config.get("pathAC2") })
            });
            
            fetch(request)
            .then(function(response){
                return response.json();
            })
            .then(function(result){
                if (result.success){
                    // qui provo il caricamento del pannello
                    this.setState({messaggio:'Dati inviati Correttamente. Controlla la tua E-Mail', classemail:'nascosto', classepassword: 'nascosto', classemostra:'nascosto', showLOGIN_PRIVACY:'nascosto'});
                } else {
                    this.setState({messaggio: result.message});
                }
            }.bind(this)).catch(function() {
                this.setState({messaggio: 'Errore invio dati'});
            }.bind(this));
        }
        
    }
  
    
    caricaAreaClientiPanel()
    {
        let datainfo = sessione.get('datainfo');
        
        if( utils.isObjectFull( datainfo ) === true ){ 
            // 2019-01-30
            let titolo = utils.getObjInfoSocieta( 'MS_TITOLO_AREA_CLIENTI' , 'Area Clienti' );
            document.title = titolo+" "+config.getVersion();

            ReactDOM.render(<AreaClientePanel />, document.getElementById('root')); 
        } else { setTimeout( function(){ this.caricaAreaClientiPanel(); }.bind(this) , 50 ); }
    }  

    /*
    tornalogin = (event) => {
        ReactDOM.render(<LoginWindow />, document.getElementById('root'));
    }
    */
    
    tornalogin = (event) => {
        // ReactDOM.render(<LoginWindow />, document.getElementById('root'));
        /*  window.location ==>
            host: "clientisviluppo.enerp.biz"
            hostname: "clientisviluppo.enerp.biz"
            href: "https://clientisviluppo.enerp.biz/AC2/build/?auth=RP!UTmnbcvbsdjhbsdjkb,bmnbbjhjksdsd"
            origin: "https://clientisviluppo.enerp.biz"
            pathname: "/AC2/build/"
        */
       // window.location.reload();
       window.location = window.location.origin + window.location.pathname;
    }


    render() {
        return (
        <div id="main-container" className="loginpage">
        <header className={this.state.classeHeader}><span className={this.state.classLogo}>&nbsp;</span>&nbsp;</header>
        
        <Dialog dialogContentProps={{ title : this.state.textREGISTRATI }} hidden={this.state.hidden}  modalProps={{ isBlocking: true, containerClassName: 'ms-dialogMainOverride primoaccesso' }} >
        
            <div>{this.state.messaggio}</div>
            <div>
                <TextField className={this.state.classemostra} label="Codice cliente" required={true} errorMessage={this.state.codclienteError} value={this.state.codcliente} onChanged={this.codclienteChanged} iconProps={{iconName: 'Contact'}}/>
                <TextField className={this.state.classepassword} label="P.Iva/C.F." errorMessage={this.state.pivaError} required={true} value={this.state.piva} iconProps={{iconName: 'Calculator'}} onChanged={this.pivaChanged} />
                    
                <TextField className={this.state.classepassword} label="Password" errorMessage={this.state.passwordError} required={true} type="password" value={this.state.password1} iconProps={{iconName: 'Lock'}} onChanged={this.password1Changed} />
                <TextField className={this.state.classepassword} label="Ripeti Password" errorMessage={this.state.passwordError2} required={true} type="password" value={this.state.password2} iconProps={{iconName: 'Lock'}} onChanged={this.password2Changed} />
                    
                <TextField className={this.state.classemail} label="Indirizzo E-Mail" errorMessage={this.state.mailError} required={true} value={this.state.mail} iconProps={{iconName: 'Mail'}} onChanged={this.mailChanged} />
                <TextField className={this.state.classemail} label="Ripeti Indirizzo E-Mail" errorMessage={this.state.mailError2} required={true} value={this.state.mail2} iconProps={{iconName: 'Mail'}} onChanged={this.mail2Changed} />
            </div>
            
            <div className={this.state.showLOGIN_PRIVACY}>
                <div className="msGrid"><div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm2">
                        <Checkbox onChange={this._onCheckboxChange} />
                    </div>
                    <div className="ms-Grid-col ms-sm10" dangerouslySetInnerHTML={{__html: this.state.textLOGIN_PRIVACY}}></div>
                </div></div>
            </div>
            
            <DialogFooter>
                <PrimaryButton className={this.state.classemostra} text={this.state.textREGISTRATI} primary={true} onClick={this.execLogin} disabled={this.state.buttonDisabled}/>
                <DefaultButton text="Indietro" onClick={this.tornalogin} />
            </DialogFooter>
        </Dialog>
        <footer className="loginpage"><i className="ms-Icon ms-Icon--Info" aria-hidden="true"></i> Versione {this.state.version}</footer>
        </div>
        );
    }

}

export default PrimoAccesso;


// WEBPACK FOOTER //
// ./src/AcComponents/PrimoAccesso.js